import { ReactNode, useEffect, useRef } from 'react';
import Vec2 from 'vec2';

import { useDrawingShapeContext } from '../drawingShapeContext';
import { FabricCanvasContext } from './fabricCanvas.context';
import { Position } from './fabricCanvas.types';
import { useDrawFabricCanvas, useFreeDrawHandler } from './hooks';

import { DRAGGING_STATE } from '~/core/enums';
import { DrawingTabEnum } from '~/core/enums/drawing-tab.enum';
import { DrawingShape } from '~/core/models';

export const FabricCanvasProvider = ({
  children,
}: {
  children?: ReactNode;
}): JSX.Element => {
  const drawingShapesRef = useRef<DrawingShape[]>([]);
  const draggingStateRef = useRef<DRAGGING_STATE>(DRAGGING_STATE.IDLE);
  const isShapeLogicRef = useRef(true);
  const lastPositionRef = useRef<Position>({});
  const movingItemRef = useRef<DrawingShape | string | undefined>(undefined);
  const selectedDrawingTabRef = useRef<DrawingTabEnum>();
  const shapeStartDragRef = useRef<Vec2>(new Vec2(0, 0));

  const {
    getters: { drawingShapes },
  } = useDrawingShapeContext();

  useFreeDrawHandler();

  useEffect(() => {
    // Only update if the array reference changed (indicating a new state update from React)
    // This prevents overwriting mutations that are in progress
    if (drawingShapesRef.current !== drawingShapes) {
      drawingShapesRef.current = drawingShapes;
    }
  }, [drawingShapes]);

  useDrawFabricCanvas();

  const contextValue = {
    draggingStateRef,
    drawingShapesRef,
    isShapeLogicRef,
    lastPositionRef,
    movingItemRef,
    selectedDrawingTabRef,
    shapeStartDragRef,
  };

  return (
    <FabricCanvasContext.Provider value={contextValue}>
      {children}
    </FabricCanvasContext.Provider>
  );
};
